import { Theme } from "@mui/material/styles";
import { BrandKey } from "@cerberus/branding";
import { lightTheme, darkTheme } from "./teleheadache/theme";
import { thLightTheme } from "./teleheadache/lightTheme.th";

// CerebraLinked and every dark mode share one palette. TeleHeadache light mode follows the TH
// Portal Brand & UI guide (2026-10-11) and is its own theme; TH dark is still the shared one.
const THEMES: Record<BrandKey, { light: Theme; dark: Theme }> = {
  cerebralinked: { light: lightTheme, dark: darkTheme },
  mtc: { light: lightTheme, dark: darkTheme },
  th: { light: thLightTheme, dark: darkTheme },
};

/** Resolve the light + dark MUI themes for a brand. */
export function getBrandThemes(key: BrandKey): { light: Theme; dark: Theme } {
  return THEMES[key];
}

/**
 * Brands that default to their dark theme. CerebraLinked's identity is the dark
 * brain logo, so its portal ships on the existing dark theme; TeleHeadache stays
 * light-by-default (follows the dark-mode toggle).
 */
export function brandPrefersDark(key: BrandKey): boolean {
  return key === "cerebralinked" || key === "mtc";
}

/**
 * Brands that default to "simple / accessible mode" — larger type, spacing, touch
 * targets and contrast, for cognitively impaired / older memory-care patients and
 * their caregivers. Defaults ON for CerebraLinked (memory-care); TeleHeadache stays
 * on the standard dense UI. The effect is still gated to the patient audience and is
 * a device-local, caregiver-overridable preference (see SimpleModeContext).
 */
export function brandPrefersSimple(key: BrandKey): boolean {
  return key === "cerebralinked" || key === "mtc";
}
